import { Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { JdOptionComponent } from './jd-option.component';

@Component({
  selector   : 'jd-option-group',
  templateUrl: './jd-option-group.component.html'
})
export class JdOptionGroupComponent {
  _label: string | TemplateRef<void>;
  isLabelString: boolean;
  @ContentChildren(JdOptionComponent) listOfJdOptionComponent: QueryList<JdOptionComponent>;

  @Input()
  set jdLabel(value: string | TemplateRef<void>) {
    this.isLabelString = !(value instanceof TemplateRef);
    this._label = value;
  }

  get jdLabel(): string | TemplateRef<void> {
    return this._label;
  }

}
